/**
 * Endpoints admin — Modération du système d'avis (annuaire Global Prévention).
 */
import { qs } from '../../utils/queryString.js'

export const avisEndpoints = {
  signalements: (params) => `/api/avis/signalements${qs(params)}`,
  signalementDetail: (id) => `/api/avis/signalements/${id}`,
  traiterSignalement: (id) => `/api/avis/signalements/${id}`,
  supprimerAvis: (id) => `/api/avis/${id}`,
  bloquerFormateur: (id) => `/api/avis/formateurs/${id}/bloquer`,
  debloquerFormateur: (id) => `/api/avis/formateurs/${id}/debloquer`,
  formateursBloques: (params) => `/api/avis/formateurs/bloques${qs(params)}`,
  historique: (params) => `/api/avis/historique${qs(params)}`,
}
